var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 9.5C40.4375 9.5 12.5 37.4375 12.5 72C12.5 106.563 40.4375 134.5 75 134.5C109.563 134.5 137.5 106.563 137.5 72C137.5 37.4375 109.563 9.5 75 9.5ZM101.875 98.875C99.4375 101.312 95.5 101.312 93.0625 98.875L75 80.8125L56.9375 98.875C54.5 101.312 50.5625 101.312 48.125 98.875C45.6875 96.4375 45.6875 92.5 48.125 90.0625L66.1875 72L48.125 53.9375C45.6875 51.5 45.6875 47.5625 48.125 45.125C50.5625 42.6875 54.5 42.6875 56.9375 45.125L75 63.1875L93.0625 45.125C95.5 42.6875 99.4375 42.6875 101.875 45.125C104.312 47.5625 104.312 51.5 101.875 53.9375L83.8125 72L101.875 90.0625C104.25 92.4375 104.25 96.4375 101.875 98.875Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.5eef2ae2.svg";
export { ForwardRef as ReactComponent };